// extracted by mini-css-extract-plugin
export default {"control":"control_control__BgSPn","button":"control_button__mdeGJ"};